(function () {
  const root = document.documentElement;
  const body = document.body;

  function setLocked() {
    const menuOpen = Boolean(document.querySelector('.mglv-mobile-menu.is-open'));
    const cartOpen = Boolean(document.querySelector('.mglv-cart-drawer.is-open'));
    body.classList.toggle('mglv-menu-is-open', menuOpen);
    body.classList.toggle('mglv-cart-is-open', cartOpen);
    body.style.overflow = menuOpen || cartOpen ? 'hidden' : '';
  }



  function initIntro() {
    const intro = document.querySelector('[data-mglv-intro]');
    if (!intro) {
      root.classList.add('mglv-intro-complete');
      return false;
    }

    const designMode = root.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
    const shouldRun = root.classList.contains('mglv-intro-should-run') && !designMode;

    if (!shouldRun) {
      intro.setAttribute('aria-hidden', 'true');
      root.classList.remove('mglv-intro-active');
      root.classList.add('mglv-intro-complete');
      return false;
    }

    const duration = Math.max(300, parseInt(intro.dataset.duration || '2600', 10));
    const animationDuration = Math.max(300, parseInt(intro.dataset.animationDuration || intro.dataset.animation_duration || '4000', 10));
    const visibleDuration = Math.max(duration, animationDuration);
    intro.setAttribute('aria-hidden', 'false');
    root.classList.add('mglv-intro-active');
    root.classList.remove('mglv-intro-complete');
    body.classList.add('mglv-intro-lock');

    window.setTimeout(() => {
      intro.setAttribute('aria-hidden', 'true');
      root.classList.remove('mglv-intro-should-run');
      root.classList.remove('mglv-intro-active');
      root.classList.add('mglv-intro-complete');
      body.classList.remove('mglv-intro-lock');
      try {
        sessionStorage.setItem('mglv_intro_seen', '1');
      } catch (error) {}
      window.dispatchEvent(new CustomEvent('mglv:intro:complete'));
    }, visibleDuration + 80);

    return true;
  }

  function initHeader() {
    const header = document.querySelector('[data-mglv-header]');
    if (!header) return;

    const hideEnabled = header.dataset.hideOnScroll === 'true';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const getScrollY = () => Math.max(0, window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0);
    let lastY = getScrollY();
    let ticking = false;

    function update() {
      const y = getScrollY();
      const atTop = y <= 24;
      const menuOpen = document.querySelector('.mglv-mobile-menu.is-open');

      header.classList.toggle('is-at-top', atTop);
      header.classList.toggle('is-scrolled', y > 24);

      if (!hideEnabled || menuOpen || atTop) {
        header.classList.remove('is-hidden');
        lastY = y;
        return;
      }

      const delta = y - lastY;
      const threshold = mobileQuery.matches ? 10 : 8;
      const minHideY = mobileQuery.matches ? 140 : 96;

      if (delta > threshold && y > minHideY) {
        header.classList.add('is-hidden');
      } else if (delta < -threshold) {
        header.classList.remove('is-hidden');
      }

      if (Math.abs(delta) > 1) {
        lastY = y;
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function initMenu() {
    const menu = document.querySelector('[data-mglv-mobile-menu]');
    if (!menu) return;

    const openButtons = document.querySelectorAll('[data-mglv-menu-open]');
    const closeButtons = document.querySelectorAll('[data-mglv-menu-close]');

    function open() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      setLocked();
    }

    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      setLocked();
    }

    openButtons.forEach((button) => button.addEventListener('click', open));
    closeButtons.forEach((button) => button.addEventListener('click', close));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  function initReveal() {
    const items = document.querySelectorAll('.mglv-reveal, .mglv-reveal-media');
    if (!items.length) return;

    const designMode = root.classList.contains('shopify-design-mode') || window.Shopify && window.Shopify.designMode;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (designMode || reduced) {
      items.forEach((item) => item.classList.add('is-in'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    items.forEach((item) => observer.observe(item));
  }

  function initFaq() {
    const setAnswerHeight = (button) => {
      const answer = button.nextElementSibling;
      if (!answer || !answer.classList.contains('mglv-faq__answer')) return;
      answer.style.setProperty('--mglv-faq-answer-height', `${answer.scrollHeight}px`);
    };

    const refreshFaq = (faq) => {
      faq.querySelectorAll('.mglv-faq__button').forEach(setAnswerHeight);
    };

    document.querySelectorAll('[data-mglv-faq]').forEach((faq) => {
      const buttons = Array.from(faq.querySelectorAll('.mglv-faq__button'));
      if (!buttons.length) return;

      buttons.forEach(setAnswerHeight);

      buttons.forEach((button, index) => {
        button.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
        button.addEventListener('click', (event) => {
          event.preventDefault();
          refreshFaq(faq);

          const isOpen = button.getAttribute('aria-expanded') === 'true';
          window.requestAnimationFrame(() => {
            buttons.forEach((other) => other.setAttribute('aria-expanded', 'false'));
            button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            window.requestAnimationFrame(() => refreshFaq(faq));
          });
        });
      });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => refreshFaq(faq));
        faq.querySelectorAll('.mglv-faq__answer .mglv-body').forEach((answerBody) => observer.observe(answerBody));
      }
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-mglv-faq]').forEach(refreshFaq);
    }, { passive: true });
  }

  function initCountUps() {
    const items = document.querySelectorAll('[data-mglv-countup]');
    if (!items.length) return;

    const designMode = root.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const runCount = (element) => {
      if (!element || element.dataset.counted === 'true') return;
      const target = Math.max(0, parseInt(element.dataset.target || element.textContent || '0', 10));
      const duration = Math.max(250, parseInt(element.dataset.duration || '950', 10));
      const start = performance.now();
      element.dataset.counted = 'true';
      element.textContent = '0';

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = String(Math.round(target * eased));
        if (progress < 1) {
          window.requestAnimationFrame(tick);
        } else {
          element.textContent = String(target);
        }
      };

      window.requestAnimationFrame(tick);
    };

    if (designMode || reduced) {
      items.forEach((element) => {
        element.textContent = element.dataset.target || element.textContent;
        element.dataset.counted = 'true';
      });
      return;
    }

    items.forEach((element) => {
      element.textContent = '0';
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        runCount(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

    items.forEach((element) => observer.observe(element));
  }


  function initPolicyTabs() {
    document.querySelectorAll('[data-mglv-policy-tabs]').forEach((wrap) => {
      const buttons = wrap.querySelectorAll('[data-mglv-policy-button]');
      const panels = wrap.querySelectorAll('[data-mglv-policy-panel]');
      const select = wrap.querySelector('[data-mglv-policy-select]');

      function show(index, shouldScroll) {
        buttons.forEach((button, i) => {
          button.classList.toggle('is-active', i === index);
          button.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        if (select) select.value = String(index);

        if (shouldScroll) {
          const activePanel = panels[index];
          if (!activePanel) return;

          window.requestAnimationFrame(() => {
            const isMobile = window.matchMedia('(max-width: 760px)').matches;
            const selectorEl = wrap.querySelector('.mglv-policy-mobile-selector') || select;
            const selectorHeight = isMobile && selectorEl ? Math.ceil(selectorEl.getBoundingClientRect().height) : 0;
            const headerOffset = isMobile ? selectorHeight + 84 : 132;
            const y = activePanel.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          });
        }
      }

      function scrollToPanel(index) {
        const activePanel = panels[index];
        if (!activePanel) return;

        window.requestAnimationFrame(() => {
          const isMobile = window.matchMedia('(max-width: 760px)').matches;
          if (isMobile) return;

          const headerOffset = 132;
          const y = activePanel.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        });
      }

      buttons.forEach((button, index) => button.addEventListener('click', () => {
        show(index, false);
        scrollToPanel(index);
      }));

      if (select) select.addEventListener('change', () => show(Number(select.value), false));
      show(0, false);
    });
  }


  function initCustomSelects() {
    const selects = document.querySelectorAll('[data-mglv-custom-select]');
    if (!selects.length) return;

    function closeAll(except) {
      selects.forEach((select) => {
        if (select === except) return;
        select.classList.remove('is-open');
        const button = select.querySelector('[data-mglv-custom-select-button]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    selects.forEach((select) => {
      const button = select.querySelector('[data-mglv-custom-select-button]');
      const value = select.querySelector('[data-mglv-custom-select-value]');
      const input = select.querySelector('[data-mglv-custom-select-input]');
      const menu = select.querySelector('[data-mglv-custom-select-menu]');
      const options = menu ? Array.from(menu.querySelectorAll('[data-value]')) : [];

      if (!button || !value || !input || !menu || !options.length) return;

      function open() {
        closeAll(select);
        select.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }

      function close() {
        select.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }

      function choose(option) {
        const selectedValue = option.dataset.value || option.textContent.trim();
        input.value = selectedValue;
        value.textContent = selectedValue;
        options.forEach((item) => item.setAttribute('aria-selected', item === option ? 'true' : 'false'));
        close();
        button.focus({ preventScroll: true });
      }

      button.addEventListener('click', () => {
        if (select.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });

      options.forEach((option) => option.addEventListener('click', () => choose(option)));

      select.addEventListener('keydown', (event) => {
        const isOpen = select.classList.contains('is-open');
        const currentIndex = Math.max(0, options.findIndex((option) => option.getAttribute('aria-selected') === 'true'));

        if (event.key === 'Escape') {
          close();
          button.focus({ preventScroll: true });
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (!isOpen) open();
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!isOpen) {
            open();
            return;
          }
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          const next = options[(currentIndex + direction + options.length) % options.length];
          choose(next);
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-mglv-custom-select]')) return;
      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeAll();
    });
  }


  function initSupportVideos() {
    const cards = document.querySelectorAll('[data-mglv-video-card]');
    const modal = document.querySelector('[data-mglv-video-modal]');
    if (!cards.length || !modal) return;

    const iframe = modal.querySelector('[data-mglv-video-iframe]');
    const title = modal.querySelector('[data-mglv-video-modal-title]');
    const closeButtons = modal.querySelectorAll('[data-mglv-video-close]');

    function getYoutubeId(url) {
      if (!url) return '';
      const value = String(url).trim();

      try {
        const parsed = new URL(value);
        if (parsed.hostname.includes('youtu.be')) {
          return parsed.pathname.replace('/', '').split('/')[0];
        }

        if (parsed.searchParams.get('v')) {
          return parsed.searchParams.get('v');
        }

        const parts = parsed.pathname.split('/').filter(Boolean);
        const embedIndex = parts.findIndex((part) => part === 'embed' || part === 'shorts');
        if (embedIndex >= 0 && parts[embedIndex + 1]) {
          return parts[embedIndex + 1];
        }
      } catch (error) {}

      const match = value.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
      return match ? match[1] : '';
    }

    function open(card) {
      const id = getYoutubeId(card.dataset.youtubeUrl);
      if (!id || !iframe) return;

      if (title) title.textContent = card.dataset.videoTitle || 'Support Film';
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mglv-video-is-open');
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (iframe) iframe.src = '';
      document.body.classList.remove('mglv-video-is-open');
    }

    cards.forEach((card) => {
      const id = getYoutubeId(card.dataset.youtubeUrl);
      const thumb = card.querySelector('[data-mglv-video-thumb]');
      if (thumb && id) {
        thumb.src = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
      }

      card.addEventListener('click', () => open(card));
    });

    closeButtons.forEach((button) => button.addEventListener('click', close));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
    });
  }


  function initCountUpStats() {
    const counters = document.querySelectorAll('[data-mglv-count]');
    if (!counters.length) return;

    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function formatValue(value, format) {
      if (format === 'comma') {
        return Math.round(value).toLocaleString('en-US');
      }
      return String(Math.round(value));
    }

    function animateCounter(el) {
      if (el.dataset.countStarted === 'true') return;
      el.dataset.countStarted = 'true';

      const target = Number(el.dataset.countValue || '0');
      const suffix = el.dataset.countSuffix || '';
      const format = el.dataset.countFormat || '';
      const stat = el.closest('.mglv-stat');

      if (!target || prefersReducedMotion) {
        el.textContent = formatValue(target, format) + suffix;
        if (stat) stat.classList.add('is-counted');
        return;
      }

      const duration = 1450;
      const delay = Math.min(Number(el.dataset.countDelay || '0'), 600);
      const startTime = performance.now() + delay;

      function tick(now) {
        if (now < startTime) {
          requestAnimationFrame(tick);
          return;
        }

        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = target * eased;
        el.textContent = formatValue(current, format) + suffix;

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = formatValue(target, format) + suffix;
          if (stat) stat.classList.add('is-counted');
        }
      }

      requestAnimationFrame(tick);
    }

    counters.forEach((counter, index) => {
      counter.dataset.countDelay = String(index * 120);
    });

    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCounter);
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });

    counters.forEach((counter) => observer.observe(counter));
  }


  function initPressPdfLinks() {
    const links = document.querySelectorAll('[data-mglv-pdf-link]');
    if (!links.length) return;

    links.forEach((link) => {
      if (link.dataset.pdfMobileBound === 'true') return;
      link.dataset.pdfMobileBound = 'true';

      link.addEventListener('click', (event) => {
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
        if (!isMobile) return;

        const href = link.getAttribute('href');
        if (!href) return;

        event.preventDefault();
        window.location.assign(href);
      });
    });
  }

  function init() {
    const introRunning = initIntro();

    initHeader();
    initMenu();
    initFaq();
    initPolicyTabs();
    initCustomSelects();
    initSupportVideos();
    initPressPdfLinks();

    const startMotion = () => {
      initReveal();
      initCountUps();
      initCountUpStats();
    };

    if (introRunning) {
      window.addEventListener('mglv:intro:complete', startMotion, { once: true });
    } else {
      startMotion();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.mglvSetBodyLock = setLocked;
})();
